import { BLIP_EVENTS } from './blip-sac-events-dataset';

export class BlipSacEventsTrigger {

    public verifyUrlAndFireEventIfNeedly() {
        const eventName = this.getSacBlipEventInUrlIfExists();

        if (eventName) {
            this.triggerAnEventToBlip(eventName);
        }
    }

    protected getSacBlipEventInUrlIfExists() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        return urlParams.get('SAC_Blip');
    }

    protected triggerAnEventToBlip(eventName: string) {
        if (eventName.indexOf('.') > -1) {
            const eventNameSplited = eventName.split('.');
            if (eventNameSplited.length > 0) {
                eventName = eventNameSplited[eventNameSplited.length - 1];
            }
        }
        
        // When event is not a fixed event with a fixed structure
        let eventToSend: CustomEvent = new CustomEvent('BlipWidget.event', { 'detail': eventName });

        const fixedStructureEvent = BLIP_EVENTS.find(
          (event) => event.name == eventName
        );

        if (fixedStructureEvent) {
            eventToSend = fixedStructureEvent.event;
        }

        // Timeout is needly because blip component can be slowly to load
        setTimeout(() => {
            window.dispatchEvent(eventToSend);
            console.log(`Event transmited to Blip -> ${eventName}`, eventToSend);
        }, 700);
    }
}